<template>
    <div>
        <div class="flex row  q-pa-md justify-between  bg-page-nav" >
                    <div class="flex row items-center">
                        <div class="q-mr-sm text-body2">状态:</div>
                        <el-select class="q-mr-md" v-model="project" placeholder="请选择" size="mini" style="width: 120px;">
                            <el-option
                                    v-for="item in projectOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                        <el-button  @click="handleInquireCommand" size="mini" plain type="primary">查询</el-button>
                    </div>
                        <el-button type="primary" plain size="mini" @click="createSolutionHandle">新建项目需求</el-button>
                </div>
        <div>
                <el-table
                        :data="tableData"
                        class="table"
                        id="table"
                        border
                        >
                    <el-table-column
                            prop="project_name"
                            label="项目名称"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="c_custom_name"
                            label="客户名称"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="c_custom_phone"
                            label="联系电话"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="project_address"
                            label="地址"
                    >
                    </el-table-column>
<!--                    <el-table-column-->
<!--                            prop="zhuangxiu_budget"-->
<!--                            label="装修预算"-->
<!--                    >-->
<!--                    </el-table-column>-->
<!--                    <el-table-column-->
<!--                            prop="jianzhu_mianji"-->
<!--                            label="建筑面积"-->
<!--                    >-->
<!--                    </el-table-column>-->
<!--                    <el-table-column-->
<!--                            prop="taonei_mianji"-->
<!--                            label="套内面积"-->
<!--                    >-->
<!--                    </el-table-column>-->
<!--                    <el-table-column-->
<!--                            prop="changzhu_renkou"-->
<!--                            label="常住人口"-->
<!--                    >-->
<!--                    </el-table-column>-->
<!--                        <el-table-column-->
<!--                                prop="gaofeng_renkou"-->
<!--                                label="高峰人口"-->
<!--                        >-->
<!--                    </el-table-column>-->
<!--                    <el-table-column-->
<!--                            prop="shiyong_xihao"-->
<!--                            label="使用喜好"-->
<!--                    >-->
<!--                    </el-table-column>-->
                        <el-table-column
                                prop="apply_date"
                                label="申请审核时间"
                        >

                    </el-table-column>
                    <el-table-column
                            prop="project_stage_name"
                            label="项目阶段"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="create_date"
                            label="创建时间"
                    >
                    </el-table-column>
<!--                    fixed="right"-->
                    <el-table-column
                            label="操作"
                            width="150" >
                        <template slot-scope="scope">
                            <el-button style="margin-bottom: 10px;" @click="editSolutionHandle(scope.row.project_hash)" size="mini">编辑</el-button>
                            <el-button  v-if="scope.row.project_stage == '0'" @click="applyHandle(scope.row.project_hash)" size="mini">申请</el-button>
                            <el-button  v-else @click="revokeHandle(scope.row.project_hash)" size="mini">撤销</el-button>
                            <el-button style="margin-left: 0px;" @click="deleteSolutionHandle(scope.row.project_hash)" size="mini">删除</el-button>
<!--                            <div @click="infoSolutionHandle(scope.row.project_hash)">项目详情</div>-->
                            <el-button  @click="planSolutionHandle(scope.row.project_hash, scope.row.scheme_hash)" size="mini">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>

            </div>
        <div class="text-right q-mt-md">
            <el-pagination
                    small
                    layout="prev, pager, next"
                    :page-count="all_page"
                    @current-change="handleSizeChange"
            >
            </el-pagination>
        </div>
    </div>

</template>

<script>

    export default {
        // 管理主页
        // name: '客户方案',
        data() {
            return {
                tableData: [],
                all_page:0,
                page:0,
                project: 'all',
                cost: '',

                dealer: '',//经销商
                cTerminal: '',//C端客户
                principal: '',// 负责人
                time: '',//时间
                dialogVisible: false,
                dialogTitle: '',
                principalDialog: false,
                input: '',//负责人
                project_stage:'',//筛选
                projectOptions:[{label:'全部',value:'all'},{label:'待申请',value:'0'},{label:'待分配',value:'1'},{label:'进行中',value:'2'}],

            }
        },
        created() {

            this.getCustomerSolutionList()
        },
        methods: {
            editSolutionHandle(chash){
                this.$router.push({name:'newPlan',params:{type:'edit',project_hash:chash,disable:false,title:'编辑项目方案'}})
            },
            infoSolutionHandle(chash){
                this.$router.push({name:'newPlan',params:{type:'info',project_hash:chash,disable:true,title:'项目详情'}})
            },
            planSolutionHandle(chash,scheme_hash){
                if (scheme_hash){
                    this.$router.push({name:'basic_info',params:{type:'info',project_hash:chash,disable:true,title:'方案详情',scheme_hash:scheme_hash}})
                }else{
                    this.$router.push({name:'basic_info',params:{type:'info',project_hash:chash,disable:true,title:'方案详情',scheme_hash:'none'}})
                }

            },
            deleteSolutionHandle(chash){
                this.$confirm('此操作将永久删除该项目方案, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    this.$http({
                        url: 'project_delete',
                        data: {
                            "project_hash":chash,
                        }
                    }).then((res)=>{
                        console.log(res.data.project_list)
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.project_stage = 'all';
                        this.getCustomerSolutionList(this.project_stage,'1');
                    }).catch((err)=>{

                        console.log(err)
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleSizeChange(e) {
                this.page = e
                this.project_stage = this.project;
                this.getCustomerSolutionList(this.project_stage,this.page);
            },
            applyHandle(chash){
                console.log(chash)
                this.$http({
                    url: 'apply_check',
                    data: {
                        "project_hash":chash,
                    }
                }).then((res)=>{
                    console.log(res)
                    this.$message({
                        message: '申请审核成功',
                        type: 'success'
                    });
                    this.project_stage = 'all';
                    this.page = 1;
                    this.getCustomerSolutionList(this.project_stage,'1');
                }).catch((err)=>{

                    console.log(err)
                })
            },
            revokeHandle(chash){
                this.$confirm('正在撤销该项目方案, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    this.$http({
                        url: 'project_revoke',
                        data: {
                            "project_hash":chash,
                        }
                    }).then((res)=>{
                        console.log(res.data.project_list)
                        this.$message({
                            type: 'success',
                            message: '撤销成功!'
                        });
                        this.project_stage = 'all';
                        this.page = 1;
                        this.getCustomerSolutionList(this.project_stage,'1');
                    }).catch((err)=>{

                        console.log(err)
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });


            },
            // 查询
            handleInquireCommand() {
                console.log('查询')
                this.project_stage = this.project;
                this.page = 1;
                this.getCustomerSolutionList(this.project_stage,this.page);
            },
            createSolutionHandle() {
                // this.$router.push({name:'newPlan'})
                this.$router.push({name:'newPlan',params:{type:'add',customer_hash:'',disable:false,title:'新建项目方案'}})

            },
            getCustomerSolutionList(project,page){
                this.$http({
                    url: 'project_list',
                    data: {
                        "project_stage":project,
                        'page':page
                    }
                }).then((res)=>{
                    console.log(res.data.project_list)
                    this.tableData = res.data.project_list;
                    this.all_page = res.all_page;

                }).catch((err)=>{

                    console.log(err)
                })
            },

        }
    }
</script>

<style scoped>

</style>
